import {
  agencyCreateInfluencerFacts,
  agencyEditInfluencerFact,
  createInfluencerFacts,
  deleteAgencyInfluencerFact,
  deleteInfluencerFact,
  editInfluencerFact,
  fetchAgencyInfluencerFacts,
  fetchInfluencerFacts,
} from './asyncThunks';

export const fetchInfluencerFactsBuilder = builder => {
  builder.addCase(fetchInfluencerFacts.pending, (state, { meta }) => {
    const page = meta.arg.page;
    if (page === 1) {
      state.fetchInfluencerFactsInfo.pending = true;
    } else {
      state.fetchInfluencerFactsInfo.fetchMorePending = true;
    }
  });
  builder.addCase(fetchInfluencerFacts.fulfilled, (state, { payload }) => {
    const { data, maxReached, page } = payload;
    if (page === 1) {
      state.fetchInfluencerFactsInfo.data = data;
      state.fetchInfluencerFactsInfo.pending = false;
    } else {
      state.fetchInfluencerFactsInfo.fetchMorePending = false;
      state.fetchInfluencerFactsInfo.data = [...state.fetchInfluencerFactsInfo.data, ...data];
    }
    state.fetchInfluencerFactsInfo.maxReached = maxReached;
  });
  builder.addCase(fetchInfluencerFacts.rejected, state => {
    state.fetchInfluencerFactsInfo.pending = false;
    state.fetchInfluencerFactsInfo.fetchMorePending = false;
  });
};

export const fetchAgencyInfluencerFactsBuilder = builder => {
  builder.addCase(fetchAgencyInfluencerFacts.pending, (state, { meta }) => {
    const page = meta.arg.page;
    if (page === 1) {
      state.fetchInfluencerFactsInfo.pending = true;
    } else {
      state.fetchInfluencerFactsInfo.fetchMorePending = true;
    }
  });
  builder.addCase(fetchAgencyInfluencerFacts.fulfilled, (state, { payload }) => {
    const { data, maxReached, page } = payload;
    if (page === 1) {
      state.fetchInfluencerFactsInfo.data = data;
      state.fetchInfluencerFactsInfo.pending = false;
    } else {
      state.fetchInfluencerFactsInfo.fetchMorePending = false;
      state.fetchInfluencerFactsInfo.data = [...state.fetchInfluencerFactsInfo.data, ...data];
    }
    state.fetchInfluencerFactsInfo.maxReached = maxReached;
  });
  builder.addCase(fetchAgencyInfluencerFacts.rejected, state => {
    state.fetchInfluencerFactsInfo.pending = false;
    state.fetchInfluencerFactsInfo.fetchMorePending = false;
  });
};

export const createInfluencerFactsBuilder = builder => {
  builder.addCase(createInfluencerFacts.pending, state => {
    state.pending.createInfluencerFacts = true;
  });
  builder.addCase(createInfluencerFacts.fulfilled, (state, { payload }) => {
    const { influencerFacts } = payload;
    state.pending.createInfluencerFacts = false;
    state.fetchInfluencerFactsInfo.data = [...influencerFacts, ...state.fetchInfluencerFactsInfo.data];
  });
  builder.addCase(createInfluencerFacts.rejected, state => {
    state.pending.createInfluencerFacts = false;
  });
};

export const agencyCreateInfluencerFactsBuilder = builder => {
  builder.addCase(agencyCreateInfluencerFacts.pending, state => {
    state.pending.createInfluencerFacts = true;
  });
  builder.addCase(agencyCreateInfluencerFacts.fulfilled, (state, { payload }) => {
    const { influencerFacts } = payload;
    state.pending.createInfluencerFacts = false;
    state.fetchInfluencerFactsInfo.data = [...influencerFacts, ...state.fetchInfluencerFactsInfo.data];
  });
  builder.addCase(agencyCreateInfluencerFacts.rejected, state => {
    state.pending.createInfluencerFacts = false;
  });
};

export const deleteInfluencerFactBuilder = builder => {
  builder.addCase(deleteInfluencerFact.pending, state => {
    state.pending.deleteInfluencerFact = true;
  });
  builder.addCase(deleteInfluencerFact.fulfilled, (state, { payload }) => {
    const { influencerFactId } = payload;
    state.pending.deleteInfluencerFact = false;
    state.fetchInfluencerFactsInfo.data = state.fetchInfluencerFactsInfo.data.filter(d => d.id !== influencerFactId);
  });
  builder.addCase(deleteInfluencerFact.rejected, state => {
    state.pending.deleteInfluencerFact = false;
  });
};

export const deleteAgencyInfluencerFactBuilder = builder => {
  builder.addCase(deleteAgencyInfluencerFact.pending, state => {
    state.pending.deleteInfluencerFact = true;
  });
  builder.addCase(deleteAgencyInfluencerFact.fulfilled, (state, { payload }) => {
    const { influencerFactId } = payload;
    state.pending.deleteInfluencerFact = false;
    state.fetchInfluencerFactsInfo.data = state.fetchInfluencerFactsInfo.data.filter(d => d.id !== influencerFactId);
  });
  builder.addCase(deleteAgencyInfluencerFact.rejected, state => {
    state.pending.deleteInfluencerFact = false;
  });
};

export const editInfluencerFactBuilder = builder => {
  builder.addCase(editInfluencerFact.pending, state => {
    state.pending.editInfluencerFact = true;
  });
  builder.addCase(editInfluencerFact.fulfilled, (state, { payload }) => {
    const { influencerFact } = payload;
    state.pending.editInfluencerFact = false;
    state.fetchInfluencerFactsInfo.data = state.fetchInfluencerFactsInfo.data.map(d =>
      d.id === influencerFact.id ? influencerFact : d,
    );
  });
  builder.addCase(editInfluencerFact.rejected, state => {
    state.pending.editInfluencerFact = false;
  });
};

export const agencyEditInfluencerFactBuilder = builder => {
  builder.addCase(agencyEditInfluencerFact.pending, state => {
    state.pending.editInfluencerFact = true;
  });
  builder.addCase(agencyEditInfluencerFact.fulfilled, (state, { payload }) => {
    const { influencerFact } = payload;
    state.pending.editInfluencerFact = false;
    state.fetchInfluencerFactsInfo.data = state.fetchInfluencerFactsInfo.data.map(d =>
      d.id === influencerFact.id ? influencerFact : d,
    );
  });
  builder.addCase(agencyEditInfluencerFact.rejected, state => {
    state.pending.editInfluencerFact = false;
  });
};
